<template>
  <div id="app">

    <div class=" bg-white margin-center   margin-top-15 backgroud"
         style="padding-top:10px;min-height: 550px;">
      <div v-if="length>1"
           class="  width flex flex-wrap bg-white "
           style="margin:0px auto 10px">
        <p @click="checkCatalogsItem(item.ChannelId)"
           v-for="(item, index) in catalogs"
           :key="index"
           class="font-size-16   padding-l-r-20"
           :class="ChannelId == item.ChannelId?'font-color-red':'font-color-666-red'"
           style="line-height:30px;height: 30px; cursor: pointer;text-decoration:none">{{item.ChannelName}}</p>
      </div>
      <div class="flex flex-direction align-center ">
        <div v-for="(item, index) in dataList"
             :key="index"
             @click="articleIndex(item.Id)"
             :style="index!=0?'border-top: #eeeeee dashed 1px;':''"
             class="information">
          <div class="flex font-size-20 font-color-black"
               :title="item.Title"
               style="align-items: baseline;">
            <p class="text-line1 click"
               style="cursor: pointer;">{{item.Title}}</p>
            <span class=" font-size-14 font-color-999 "
                  style="text-align:left;width: 160px;margin-left: 15px;">{{item.CreateTime}}</span>
          </div>
          <p style="text-align: left;margin-top:14px"
             :title="item.Description"
             class=" font-size-14 font-color-999 text-line1">{{item.Description}}</p>
        </div>
      </div>
    </div>
    <div style=" margin-top: 20px; ">
      <el-pagination @size-change="handleSizeChange"
                     :current-page.sync="currentPage"
                     @current-change="handleCurrentChange"
                     :page-size="1"
                     layout="prev, pager, next"
                     :total="totalPage">
      </el-pagination>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  name: 'app',

  data () {
    return {
      currentPage: 1,
      dataList: [],
      totalPage: 1,
      ChannelId: 0,
      catalogs: [{
        ChannelName: "全部",
        ChannelId: 0,
      }],
    }
  },
  computed: {
    length () {
      return this.catalogs.length
    }
  },
  created () {
    // this.ChannelId = this.$route.params.ChannelId||0;
    // this.getCatalogs();
    // if(this.ChannelId == 0)
    // this.getCourseList(1)
    // console.log('created');

  },
  mounted () {

    this.ChannelId = this.$route.params.ChannelId || 0;


    this.getCatalogs();
    if (this.ChannelId == 0) {
      this.getCourseList(1)
    }

  },
  methods: {
    articleIndex (Id) {
      this.$router.push({ path: '/infordes', query: { "Id": Id } })
    },
    checkCatalogsItem (index) {
      if (this.ChannelId != index) {
        this.ChannelId = index;
        this.getCourseList(1);
        this.currentPage = 1
      }

    },
    getCourseList (index) {
      var that = this;
      this.getRequest('api/v1/authorinfo/GetArticlesListByPage', {
        ChannelId: this.ChannelId,
        PageIndex: index,
        PageSize: 15
      }).then(data => {
        if (data.IsSuccess) {
          for (var i = 0; i < data.Data.DataList.length; i++) {
            data.Data.DataList[i].CreateTime = common.formatDateYMD(data.Data.DataList[i].CreateTime).allDatatime
          }
          that.dataList = data.Data.DataList
          that.totalPage = data.Data.TotalPage
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    handleSizeChange (val) {

    },
    handleCurrentChange (val) {

      window.scrollTo(0, 0)
      this.getCourseList(val)

    },
    getCatalogs () {
      var that = this;
      this.getRequest('api/v1/authorinfo/GetChannelList').then(data => {

        if (data.IsSuccess) {
          var list = [];

          list = that.catalogs.concat(data.Data);
          that.catalogs = list;
          if (that.ChannelId != 0) {
            this.currentPage = 1
            this.getCourseList(1);

          }
        } else {
          this.$message.error(data.Message)
        }
      })
    },
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.click:hover {
  color: #d30000;
}
.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}
.information {
  box-sizing: border-box;
  width: 1159px;
  padding: 20px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/information/index.vue